import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';

export class Carousel {

    constructor( target = '.js-carousel', options = {} ) {
        this.target = target;

        this.options = {
            slideClass: 'js-carousel__slide',
            wrapperClass: 'js-carousel__track',
            slideActiveClass: 'js-carousel__slide--active',
            noSwipingClass: 'js-carousel__no-swipe',
            modules: [Navigation, Pagination, Mousewheel],
            mousewheel: {
                sensitivity: 3
            },
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector( 'body' ),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init() {
        this.sliders = [];
        this.el = Array.from( document.querySelectorAll( this.target ) );

        if( this.el.length ) {
            this.sliderObserver = new IntersectionObserver( ( entries, observer ) => {
                this.create( entries, this );
            }, this.observerOptions );

            this.el.forEach( $el => {
                this.sliderObserver.observe( $el );
            });
        }
    }

    create( entries, instance ) {
        entries.forEach( ( entry ) => {
            if( entry.isIntersecting ) {

                const $el = entry.target;
                const style = $el.dataset.style;

                let options;

                let $next = '.js-carousel__next';
                let $prev = '.js-carousel__prev';

                if( style == 'vertical' ) {
                    options = {
                        ...this.options,
                        direction: "vertical",
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        loop: false,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'c-data-summary__control--disabled',
                        },
                    }
                } else {
                    options = {
                        ...this.options,
                        slidesPerView: 1,
                        spaceBetween: 16,
                        loop: true,
                    }
                }

                this.sliders.push( new Swiper( $el, options ) );
                this.sliderObserver.unobserve( $el );
            }
        });
    }

    reload() {
        this.sliders.forEach( slider => {
            slider.update();
        });
    }

    destroy() {
        Swiper.destroy();
    }
}
